import alignCenter from '@tabler/icons/outline/align-center.svg?raw';
import alignJustified from '@tabler/icons/outline/align-justified.svg?raw';
import alignLeft from '@tabler/icons/outline/align-left.svg?raw';
import alignRight from '@tabler/icons/outline/align-right.svg?raw';
import arrowBackUp from '@tabler/icons/outline/arrow-back-up.svg?raw';
import arrowForwardUp from '@tabler/icons/outline/arrow-forward-up.svg?raw';
import bold from '@tabler/icons/outline/bold.svg?raw';
import clearFormatting from '@tabler/icons/outline/clear-formatting.svg?raw';
import code from '@tabler/icons/outline/code.svg?raw';
import italic from '@tabler/icons/outline/italic.svg?raw';
import link from '@tabler/icons/outline/link.svg?raw';
import list from '@tabler/icons/outline/list.svg?raw';
import listNumbers from '@tabler/icons/outline/list-numbers.svg?raw';
import palette from '@tabler/icons/outline/palette.svg?raw';
import photo from '@tabler/icons/outline/photo.svg?raw';
import separatorHorizontal from '@tabler/icons/outline/separator-horizontal.svg?raw';
import table from '@tabler/icons/outline/table.svg?raw';
import textSize from '@tabler/icons/outline/text-size.svg?raw';
import typography from '@tabler/icons/outline/typography.svg?raw';
import underline from '@tabler/icons/outline/underline.svg?raw';
import unlink from '@tabler/icons/outline/unlink.svg?raw';
import { mapValues } from 'remeda';

// Tabler ships these at the app's stroke weight minus a notch; a touch heavier than
// the `stroke={1.5}` used by the @tabler/icons-react components elsewhere,
// which reads too faint at toolbar size.
const toEditorWeight = (svg: string): string =>
  svg.replace('stroke-width="2"', 'stroke-width="1.75"');

// Keys are Jodit control names — a button with no explicit `icon` resolves its
// icon by its own name.
const TOOLBAR_ICONS = mapValues(
  {
    undo: arrowBackUp,
    redo: arrowForwardUp,
    bold,
    italic,
    underline,
    eraser: clearFormatting,
    brush: palette,
    font: typography,
    fontsize: textSize,
    hr: separatorHorizontal,
    ul: list,
    ol: listNumbers,
    link,
    unlink,
    image: photo,
    table,
    left: alignLeft,
    center: alignCenter,
    justify: alignJustified,
    right: alignRight,
    source: code,
  },
  toEditorWeight,
);

export const getToolbarIcon = (name: string): string | undefined =>
  TOOLBAR_ICONS[name as keyof typeof TOOLBAR_ICONS];
